export const EventTypes = {
    ReloadActions: 'reloadActions',
    ResetForm: 'resetForm',
} as const;

export default EventTypes;
